
<!-- svelte-ignore a11y-label-has-associated-control -->
<label class='block mb-2 mt-4'>
  <span>{@html value}</span>
  <slot></slot>
</label>

<script lang='ts'>
  export let value: string | null = null;
</script>